import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  > div {
    margin: 0.8rem 0;
  }
`

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.semiBold};
    line-height: 1;
    margin-top: 0.8rem;
    margin-left: 6px;
    padding-bottom: 0.3rem;
    color: #000;
  `}
`

export const RadioYesOrNoOptions = styled.div`
  display: flex;

  > div {
    margin-right: 18px;
  }
`

export const ScaleContainer = styled.div`
  display: flex;
  gap: 0 0.4rem;
`
